module.exports = __webpack_public_path__ + "67e6355612749bdb32866842a0d0525a.png";